<div
    class="wrapper"
    *ngrxLet="{
        isLoggedIn: isLoggedIn$,
        isHeaderUserButtonShortMode: isHeaderUserButtonShortMode$,
        userName: userName$,
    } as vm"
>
    <div class="user-wrapper">
        <dtm-ui-header-user-button
            [isUserLoggedIn]="vm.isLoggedIn"
            [isShortMode]="vm.isHeaderUserButtonShortMode"
            [userName]="vm.userName"
            (logout)="logout()"
        >
        </dtm-ui-header-user-button>
    </div>
</div>
